import(/* webpackMode: "eager" */ "/vercel/path1/app/faq/page.tsx");
